
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".8","y":".8","width":"62.4","height":"46.4","rx":".8","stroke":"currentColor","stroke-width":"1.6"}}),_c('rect',{attrs:{"x":"6","y":"38","width":"9","height":"7.342","rx":".713","transform":"rotate(-90 6 38)","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"15.178","y":"38","width":"18.9","height":"7.342","rx":".713","transform":"rotate(-90 15.178 38)","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"24.356","y":"38","width":"14.4","height":"7.342","rx":".713","transform":"rotate(-90 24.356 38)","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"33.533","y":"38","width":"27","height":"7.342","rx":".713","transform":"rotate(-90 33.533 38)","fill":"#E0E2E6"}}),_c('rect',{attrs:{"x":"47.626","y":"16.625","width":"9.75","height":"2.438","rx":".5","fill":"currentColor"}}),_c('rect',{attrs:{"x":"47.626","y":"21.312","width":"9.75","height":"2.438","rx":".5","fill":"currentColor"}}),_c('rect',{attrs:{"x":"47.626","y":"26","width":"9.75","height":"2.438","rx":".5","fill":"currentColor"}}),_c('rect',{attrs:{"x":"47.626","y":"30.687","width":"9.75","height":"2.438","rx":".5","fill":"currentColor"}})])
          )
        }
      }
    